import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { toBoolean } from 'ng-zorro-antd/core/util';
declare global {
  interface Window {
    Pusher: any;
  }
}

window.Pusher = Pusher;

@Injectable({
  providedIn: 'root'
})
export class LaravelEchoService {
  public echo: Echo<any>;

  // Echo is created lazily after login. Consumers await this before attaching listeners, instead of racing the
  // asynchronous bootstrap that calls initEcho — a ReplaySubject so late subscribers are told at once if it is ready.
  private readonly readySource = new ReplaySubject<void>(1);
  public readonly ready$: Observable<void> = this.readySource.asObservable();

  public initEcho(token: string): void {
    this.echo = new Echo({
      authEndpoint: environment.appRoot + '/broadcasting/auth',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      broadcaster: 'reverb',
      key: environment.echoKey,
      wsHost: environment.echoHost,
      wsPort: parseInt(environment.echoPort),
      forceTLS: toBoolean(environment.echoHttps),
      transports: ['ws'],
      disableStats: true,
    }
    );

    // Echo is ready — anyone waiting to attach a listener can do so now.
    this.readySource.next();
  }
}
